// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","cta":"page_cta__s3k6L"};